module.exports = "/packs/images/svg/ireland/accessibility/lift~bce311115726096a7e332d62a4ab1ab4.svg";